import '../css/humanitarian.scss';
import $ from '@modules/jquery-import';
import Events from '@core/Events';
import Module from '@core/Module';
import {jqueryValidate, jqueryScrolling} from '@modules/lazy-imports';

$( document ).ready( function () {
    var humanitarian_form = new Humanitarian().initialize( '#humanitarianForm' );
} );

var Humanitarian = function () {
    return $.extend( {}, Module, Events, {
        elements: {
            '#humanitarianVolunteersList': 'volunteer_list',
            '#humanitarianVolunteersList input:not(".total")': 'volunteer_fields',
            '#humanitarianVolunteersList .total': 'volunteer_total',
            'input[type="submit"]': 'submitButton',
            'input[type="text"], textarea': 'inputFields'
        },

        events: {
            'focus #humaniratianProductList li:last-child input.itemNumber': 'increment_field',
            'change volunteer_fields': 'update_volunteer_total',
            'change input[type="file"]': 'validate_file',
            'change #agree_to_terms': 'do_validate',
            'keypress input[type="text"]': 'handle_keypress',
            'keypress textarea': 'handle_keypress',
            'click input[type="submit"]': 'do_validate'
        },

        initialize: async function ( el ) {
            await jqueryValidate();
            await jqueryScrolling();

            this.el = $( el );
            // temp hack: add fileformat class to file fields since I can't grab elements by name
            this.el.find( 'input[type="file"]' ).addClass( 'fileformat' );

            this.form = $( '#aspnetForm' ).validate( {
                onfocusout: () => {
                    // silently validate form on each field blur
                    const isValid = this.form.checkForm();
                    return isValid;
                }
            } );

            $.validator.addMethod(
                'fileformat',
                function ( value, elm ) {
                    var file = elm.files ? elm.files[0] : null,
                        threshold = 2 * (1024 * 1024), // 2MB
                        valid_formats = {
                            pdf: true,
                            txt: true,
                            doc: true,
                            docx: true,
                            ppt: true
                        };

                    if ( file ) {
                        var ext = file.name.substr(
                            file.name.lastIndexOf( '.' ) + 1
                        );
                        return valid_formats[ext] && file.size <= threshold;
                    }

                    // if no HTML5 fileList api fail silently
                    return true;
                },
                'The file size must be under 2 MB and one of the accepted formats (pdf, txt, doc, docx or ppt)'
            );

            this.do_validate = this.do_validate.bind( this );

            this.update_elements();
            this.delegate_events();

            return this;
        },

        handle_keypress: function ( e ) {
            if ( e.which === 13 ) {
                this.do_validate();
            }
        },

        do_validate: function () {
            var isValid = this.form.form();
            if ( !isValid ) {
                // scroll to first invalid element
                const firstInvalid = Object.keys( this.form.invalid )[0];
                const el = this.form.currentForm[firstInvalid];
                $( el ).scrollToElement();
            }
            return isValid;
        },

        validate_file: function ( e ) {
            // use custom validation  $.validator.addMethod('fileformat',... defined in init
            this.form.element( e.target );
        },

        increment_field: function ( e ) {
            // opacity: 1 - force visible if user holds tab key
            var li = $( e.target ).parent( 'li' ).css( {opacity: 1} ),
                li_copy = li.clone();

            li_copy.insertAfter( li ).hide().fadeIn();
            // add new fields to element cache
            this.update_elements();
        },

        update_volunteer_total: function ( e ) {
            this.volunteer_total.val( this.get_volunteer_total() );
        },

        get_volunteer_total: function () {
            var total = 0;
            this.volunteer_fields.each( function ( i, item, arr ) {
                total += parseInt( item.value, 10 ) || 0;
            } );
            return total;
        }
    } );
};
